import React from "react";
import { Alert, Button, Modal, Table } from "antd";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import type { TableColumnsType } from "antd";
import { observer } from "mobx-react-lite";
import { DropshipOrderOutboundResult } from "@/services/api/jd/order";

const useColumns = function (): TableColumnsType<DropshipOrderOutboundResult> {
    const columns: TableColumnsType<DropshipOrderOutboundResult> = [
        {
            title: "订单编号",
            key: "orderOriginalId",
            width: 150,
            render(result: DropshipOrderOutboundResult) {
                const { originalId } = result;

                return <div style={{ maxWidth: "150px" }}>{originalId}</div>;
            },
        },
        {
            title: "失败原因",
            width: 200,
            key: "message",
            dataIndex: "message",
            render(message) {
                return <span className="text-error word-break-all">{message}</span>;
            },
        },
    ];

    return columns;
};

interface OutBoundResultModalProps extends InjectBaseModalProps {
    successCount: number;
    failureCount: number;
    errorResults: DropshipOrderOutboundResult[];
}

const OutBoundResultModal: React.FC<OutBoundResultModalProps> = function (props) {
    const { open, onCancel, errorResults, successCount, failureCount } = props;

    const columns = useColumns();

    return (
        <Modal
            title="出库结果"
            mask={{ closable: false }}
            width={800}
            open={open}
            onCancel={onCancel}
            footer={<Button onClick={onCancel}>关闭</Button>}
        >
            <Alert
                type="error"
                className="mb10"
                title={
                    <div>
                        出库成功:{successCount}笔 出库失败<span className="text-error">{failureCount}</span>笔
                    </div>
                }
            />

            <Table size="small" rowKey="orderId" columns={columns} dataSource={errorResults} pagination={false} />
        </Modal>
    );
};

export default observer(OutBoundResultModal);
